<div class="navbar">
    <div class="os-button"></div>
    <div class="os-button"></div>
    <div class="os-button"></div>
</div>

<div class="page-body">
    <div class="top-row">
        <div class="circle"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>

    <div class="middle-row">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>

    <div class="flex-container">
        <div class="left">
            <div class="rect"></div>
            <div class="line fat-line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="separator"></div>
            <div class="rect"></div>
            <div class="line"></div>
        </div>

        <div class="right">
            <div class="rect"></div>
            <div class="line"></div>
            <div class="fat-line line"></div>
            <div class="line"></div>
            <div class="separator"></div>
            <div class="line"></div>
        </div>
    </div>
</div>
